<template>
  <div>
    <div class="flix-form-group">
      <div class="flix-alert flix-alert-info"><span>{{ $t('message.creditsForSms') }} <router-link class="flix-html-a flix-html-strong flix-text-info" :to="{name: 'dashboardReminder', params: {id: 'all'}}">{{ $t('message.edit', {name: $tc('message.reminder', 2)})}}</router-link></span></div>
    </div>
    <div class="flix-row" v-if="!variables.user.first_name">
      <div class="flix-col-md-12">
        <editBtn :settings="{block: true}" :onClick="function () { getEditProfile() }">
          <template v-slot:text>
            {{ $t('message.edit', { name: $t('message.profile') }) }}
          </template>
        </editBtn>
      </div>
    </div>
    <div class="flix-row" v-else>
      <div class="flix-col-md-5">
        <creditForm :onChange="function() { setAmount(false, false, false); success = false }" :callback="function (amount, price, data) { setAmount(amount, price, data) }"/>
      </div>
      <transition name="flixFadeIn">
        <div class="flix-col-md-4 flix-col-md-flix-offset-3" :key="amount + '' + success" >
          <paypalButton v-if="data && !success" :data="data" :amount="amount" :price="price" :setSuccess="function () { success = true }" />
          <success v-if="success" :data="data" :amount="amount" :price="price" />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    creditForm () { return import('@/components/credits/new/form') },
    paypalButton () { return import('@/components/credits/new/paypal.vue') },
    success () { return import('@/components/credits/new/success') }
  },
  props: {},
  data () {
    return {
      amount: false,
      price: false,
      data: false,
      success: false,
      variables: this.$getUserVariables()
    }
  },
  methods: {
    getEditProfile () {
      this.$router.push({ name: 'dashboardProfile', params: { id: 'profile' } })
    },
    setAmount (amount, price, data) {
      this.amount = amount
      this.price = price
      this.data = data
    }
  },
  mounted () {

  },
  computed: {

  }
}
</script>
<style lang="sass" scoped>
</style>
